export const defaultLocale = 'lv';
